if (!customElements.get('sticky-filters-sidebar')) {
  customElements.define(
    'sticky-filters-sidebar',
    class StickyFiltersSidebar extends HTMLElement {

      constructor() {
        super();

        this.isLogEvents = false;

        this.isSidebarFixedOnViewportTop = false;
        this.isSidebarFixedOnViewportBottom = false;

        this.collectionContent = document.getElementById('ColectionContent');
        this.collectionToolbar = document.getElementById('CollectionToolbar');

        this.lastScrollYCollectionContent = window.scrollY;
        this.prevCollectionBottom = null;
        this.trackCollectionContentPosition = this.trackCollectionContentPosition.bind(this);

        this.lastScrollYSidebar = window.scrollY;
        this.prevSidebarBottom = null;
        this.prevSidebarTop = null;
        this.trackSidebarPosition = this.trackSidebarPosition.bind(this);
      }

      connectedCallback() {
        //ignore logic if size is enough for regular sticky
        if (!this.isSidebarHeighBiggerThanViewportHeigh()) {
          return;
        }

        this.classList.remove('sticky-element');

        const r = this.collectionContent.getBoundingClientRect();
        this.prevCollectionBottom = r.bottom;

        window.addEventListener('scroll', this.trackCollectionContentPosition, { passive: true });
        window.addEventListener('resize', this.trackCollectionContentPosition);

        window.addEventListener('scroll', this.trackSidebarPosition, { passive: true });
        window.addEventListener('resize', this.trackSidebarPosition);
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.trackCollectionContentPosition);
        window.removeEventListener('resize', this.trackCollectionContentPosition);

        window.removeEventListener('scroll', this.trackSidebarPosition);
        window.removeEventListener('resize', this.trackSidebarPosition);
      }

      // Page scrolling events handling start
      collectionContentIsScrollingDown() {
        this.isLogEvents && console.log('collectionContentIsScrollingDown');

        if (this.isSidebarFixedOnViewportTop) {
          this.fixSidebarRelativelyToCollectionContent();
        }
      }

      collectionContentIsScrollingUp() {
        this.isLogEvents && console.log('collectionContentIsScrollingUp');
        if (this.getDistanceFromCollectionContentBottomToViewportBottom() < 0) {
          this.fixSidebarRelativelyToCollectionContent();
        }
      }

      collectionContentReachedViewportBottomOnScrollDown() {
        this.isLogEvents && console.log('collectionContentReachedViewportBottomOnScrollDown');

        this.stickSidebarRelativelyToCollectionContent();
      }

      sidebarReachedViewportBottomOnScrollDown() {
        this.isLogEvents && console.log('sidebarReachedViewportBottomOnScrollDown');

        if (this.getDistanceFromCollectionContentBottomToViewportBottom() < 0) {
          this.fixSidebarOnViewportBottom();
        }
      }

      sidebarReachedCollectionToolbarOnScrollUp() {
        this.isLogEvents && console.log('sidebarReachedCollectionToolbarOnScrollUp');

        const distanseBetweenSidebarTopAndCollectionContentTop = this.getDistanseBetweenSidebarTopAndCollectionContentTop();

        if (distanseBetweenSidebarTopAndCollectionContentTop > 0) {
          this.fixSidebarOnViewportTop();
        }
      }

      collectionContentTopReachedSidebarTopOnScrollUp() {
        this.isLogEvents && console.log('collectionContentTopReachedSidebarTopOnScrollUp');

        this.setDefaultSidebarPosition();
      }
      // Page scrolling events handling end


      // Sidebar position manipulating start
      setDefaultSidebarPosition() {
        this.style.position = 'relative';
        this.style.bottom = 'auto';
        this.style.top = 'auto';
        this.style.width = 'auto';

        this.isSidebarFixedOnViewportTop = false;
        this.isSidebarFixedOnViewportBottom = false;
      }

      fixSidebarOnViewportTop() {
        const width = (this.offsetWidth > 0 ? this.offsetWidth : this.parentElement.getBoundingClientRect().width - 30) + 'px';
        const top = this.getBoundingClientRect().top;
        this.style.position = 'fixed';
        this.style.top = `${top}px`;
        this.style.bottom = 'auto';
        this.style.width = width;

        this.isSidebarFixedOnViewportTop = true;
        this.isSidebarFixedOnViewportBottom = false;
      }

      fixSidebarOnViewportBottom() {
        const width = (this.offsetWidth > 0 ? this.offsetWidth : this.parentElement.getBoundingClientRect().width - 30) + 'px';
        this.style.position = 'fixed';
        this.style.bottom = '0px';
        this.style.top = 'auto';
        this.style.width = width;

        this.isSidebarFixedOnViewportTop = false;
        this.isSidebarFixedOnViewportBottom = true;
      }

      stickSidebarRelativelyToCollectionContent() {
        const targetDocTop = this.getBoundingClientRect().top + window.scrollY;
        this.style.position = 'sticky';
        this.style.top = '0px';
        this.style.bottom = 'auto';
        const normalDocTop = this.getBoundingClientRect().top + window.scrollY;
        const delta = targetDocTop - normalDocTop;
        this.style.top = `${delta}px`;

        this.isSidebarFixedOnViewportTop = false;
        this.isSidebarFixedOnViewportBottom = false;
      }

      fixSidebarRelativelyToCollectionContent() {
        const targetDocTop = this.getBoundingClientRect().top + window.scrollY;
        this.style.position = 'relative';
        this.style.top = '0px';
        this.style.bottom = 'auto';
        const normalDocTop = this.getBoundingClientRect().top + window.scrollY;
        const delta = targetDocTop - normalDocTop;
        this.style.top = `${delta}px`;

        this.isSidebarFixedOnViewportTop = false;
        this.isSidebarFixedOnViewportBottom = false;
      }
      // Sidebar position manipulating end


      // Helpers start
      getDistanceFromCollectionContentToPageTop() {
        const rect = this.collectionContent.getBoundingClientRect();
        const scrollY = window.scrollY;
        return rect.top + scrollY;
      }

      getDistanceFromCollectionContentBottomToViewportBottom() {
        const rect = this.collectionContent.getBoundingClientRect();
        const vpBottom = window.innerHeight;
        return vpBottom - rect.bottom;
      }

      getDistanceFromCollectionContentTopToViewportTop() {
        const rect = this.collectionContent.getBoundingClientRect();
        return rect.top;
      }

      getDistanceFromCollectionToolbarBottomToViewportTop() {
        const rect = this.collectionToolbar.getBoundingClientRect();
        return rect.bottom;
      }

      getDistanseBetweenSidebarTopAndCollectionContentTop() {
        const sidebarTop = this.getBoundingClientRect().top + window.scrollY;
        const contentTop = this.collectionContent.getBoundingClientRect().top + window.scrollY;
        return sidebarTop - contentTop;
      }

      isSidebarHeighBiggerThanViewportHeigh() {
        const sidebarHeight = this.getBoundingClientRect().height;
        const viewportHeight = window.innerHeight;

        return sidebarHeight > viewportHeight;
      }

      // Helpers end


      // Page scrolling events observers start
      trackCollectionContentPosition(e) {
        const currentScrollY = window.scrollY;
        const direction = currentScrollY > this.lastScrollYCollectionContent ? 'down' : (currentScrollY < this.lastScrollYCollectionContent ? 'up' : 'none');
        const rect = this.collectionContent.getBoundingClientRect();
        const currentBottom = rect.bottom;
        const vpBottom = window.innerHeight;

        if (e && e.type === 'scroll' && direction === 'down') {
          this.collectionContentIsScrollingDown();
        }

        if (e && e.type === 'scroll' && direction === 'up') {
          this.collectionContentIsScrollingUp();
        }

        if (e && e.type === 'scroll' && direction === 'up') {
          const contentTopDoc = this.getDistanceFromCollectionContentToPageTop();
          const sidebarRect = this.getBoundingClientRect();
          const prevSidebarDocTop = this.prevSidebarTop != null ? this.prevSidebarTop + this.lastScrollYSidebar : null;
          const sidebarDocTop = sidebarRect.top + currentScrollY;
          if (prevSidebarDocTop != null && prevSidebarDocTop > contentTopDoc && sidebarDocTop <= contentTopDoc) {
            this.collectionContentTopReachedSidebarTopOnScrollUp();
          }
        }

        if (
          e && e.type === 'scroll' &&
          direction === 'down' &&
          this.prevCollectionBottom != null &&
          this.prevCollectionBottom > vpBottom &&
          currentBottom <= vpBottom
        ) {
          this.collectionContentReachedViewportBottomOnScrollDown();
        }

        this.prevCollectionBottom = currentBottom;
        this.lastScrollYCollectionContent = currentScrollY;
      }

      trackSidebarPosition(e) {
        const currentScrollY = window.scrollY;
        const direction = currentScrollY > this.lastScrollYSidebar ? 'down' : (currentScrollY < this.lastScrollYSidebar ? 'up' : 'none');
        const rect = this.getBoundingClientRect();
        const currentBottom = rect.bottom;
        const vpBottom = window.innerHeight;

        if (
          e && e.type === 'scroll' &&
          direction === 'down' &&
          this.prevSidebarBottom != null &&
          this.prevSidebarBottom > vpBottom &&
          currentBottom <= vpBottom
        ) {
          this.sidebarReachedViewportBottomOnScrollDown();
        }

        if (e && e.type === 'scroll' && direction === 'up') {
          const toolbarBottomFromViewportTop = this.getDistanceFromCollectionToolbarBottomToViewportTop();

          if (
            this.prevSidebarTop != null &&
            this.prevSidebarTop > toolbarBottomFromViewportTop
          ) {
            this.sidebarReachedCollectionToolbarOnScrollUp();
          }
        }

        this.prevSidebarTop = rect.top;
        this.prevSidebarBottom = currentBottom;
        this.lastScrollYSidebar = currentScrollY;
      }
      // Page scrolling events observers start
    }
  );
}
